import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { QuoteModule } from '../../../quote/quote.module';
import { RoundInfoComponent } from './round-info/round-info.component';
import { IntroSectionComponent } from './intro-section.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    QuoteModule
  ],
  declarations: [
    RoundInfoComponent,
    IntroSectionComponent
  ],
  exports: [
    IntroSectionComponent
  ]
})
export class IntroSectionModule { }



// WEBPACK FOOTER //
// ./src/app/pages/home/intro-section/intro-section.module.ts